import React from 'react'
import logo from '../images/logo.svg'

function Navbar() {
    return (
        <>
            <header className='sticky top-0 z-50'>
                <nav className=" border-gray-200 px-2 sm:px-4 sm:py-2.5 py-4 rounded  bg-[#1F2937]">
                    <div className="container flex flex-wrap justify-between items-center mx-auto">
                        <a href="https://flowbite.com/" className="flex items-center">
                            <img src={logo} className="mr-3 h-6 sm:h-9" alt="Flowbite Logo" />
                            <span className="self-center text-xl font-bold whitespace-nowrap text-white">YoutubeDownloader</span>
                        </a>
                    </div>
                </nav>
            </header>
        </>
    )
}

export default Navbar